import { operatorApiFetch } from './apiService';

export const inventorySnapshotService = {
  getRecords: async (params) => {
    const response = await operatorApiFetch('inventory_snapshots/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  getIds: async (params) => {
    const response = await operatorApiFetch('inventory_snapshots/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  export: async (ids, params = {}) => {
    const response = await operatorApiFetch('inventory_snapshots/export', {
      method: 'POST',
      body: JSON.stringify({ ids, ...params })
    });
    return response.json();
  }
};

export default inventorySnapshotService;
